/* eslint-disable no-param-reassign */
import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
// Custom
import withFormManagement from 'hocs/WithFormManagement';
import PasswordInputField from 'components/inputFields/PasswordInputField';

const PasswordConfirmationDialog = ({
  onFieldsChange,
  onValidate,
  onRef,
  fields,
}) => {
  const handleValidate = React.useCallback(() => {
    const { currentPassword } = fields;
    if (currentPassword) {
      onValidate(currentPassword);
      return true;
    }
  }, [fields, onValidate]);

  React.useEffect(() => {
    onRef({ handleValidate });
  }, [handleValidate]);

  /* ========================================================= */
  /* UI                                                        */
  /* ========================================================= */

  return (
    <PasswordInputField
      autoComplete="new-password"
      label={<LocalizedMessage id="field.currentPassword" />}
      value={fields.currentPassword}
      onChange={(currentPassword) => onFieldsChange({ currentPassword })}
    />
  );
};

PasswordConfirmationDialog.propTypes = {
  onFieldsChange: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  onValidate: PropTypes.func.isRequired,
  onRef: PropTypes.func.isRequired,
};

const mapFieldsToProps = {
  currentPassword: {
    defaultValue: '',
  },
};

module.exports = compose(
  withFormManagement(mapFieldsToProps),
)(PasswordConfirmationDialog);



// WEBPACK FOOTER //
// ./routes/account/components/PasswordConfirmationDialog.js